"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadView = exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _router = require("@/router");
var _menu = require("@/api/menu");
var _index = _interopRequireDefault(require("@/layout/index"));
var _ParentView = _interopRequireDefault(require("@/components/ParentView"));
var permission = {
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: [],
    defaultRoutes: [],
    topbarRouters: []
  },
  mutations: {
    SET_ROUTES: function SET_ROUTES(state, routes) {
      state.addRoutes = routes;
      state.routes = _router.constantRoutes.concat(routes);
    },
    SET_SIDEBAR_ROUTERS: function SET_SIDEBAR_ROUTERS(state, routers) {
      state.sidebarRouters = routers;
    },
    SET_DEFAULT_ROUTES: function SET_DEFAULT_ROUTES(state, routes) {
      state.defaultRoutes = _router.constantRoutes.concat(routes);
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes: function GenerateRoutes(_ref) {
      var commit = _ref.commit;
      return new Promise(function (resolve) {
        // 向后端请求路由数据
        (0, _menu.getRouters)().then(function (res) {
          var sdata = JSON.parse(JSON.stringify(res.data));
          var rdata = JSON.parse(JSON.stringify(res.data));
          var sidebarRoutes = filterAsyncRouter(sdata);
          var rewriteRoutes = filterAsyncRouter(rdata, false, true);
          rewriteRoutes.push({
            path: '*',
            redirect: '/404',
            hidden: true
          });
          commit('SET_ROUTES', rewriteRoutes);
          commit('SET_SIDEBAR_ROUTERS', sidebarRoutes);
          commit('SET_DEFAULT_ROUTES', sidebarRoutes);
          resolve(rewriteRoutes);
        });
      });
    }
  }
};

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  var lastRouter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return asyncRouterMap.filter(function (route) {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.component) {
      // Layout组件特殊处理
      if (route.component === 'Layout') {
        route.component = _index.default;
      } else if (route.component === 'ParentView') {
        route.component = _ParentView.default;
      } else {
        route.component = loadView(route.component);
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      delete route.children;
      delete route.redirect;
    }
    return true;
  });
}
function filterChildren(childrenMap) {
  var lastRouter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var children = [];
  childrenMap.forEach(function (el, index) {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView' && !lastRouter) {
        el.children.forEach(function (c) {
          c.path = el.path + '/' + c.path;
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path;
      if (el.children && el.children.length) {
        children = children.concat(filterChildren(el.children, el));
        return;
      }
    }
    children = children.concat(el);
  });
  return children;
}

// export const loadView = (view) => { // 路由懒加载
//   return (resolve) => require([`@/views/${view}`], resolve)
// }
// 路由懒加载
var loadView = exports.loadView = function loadView(view) {
  if (process.env.NODE_ENV === 'development') {
    return function (resolve) {
      return require(["@/views/".concat(view)], resolve);
    };
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return function () {
      return function (specifier) {
        return new Promise(function (r) {
          return r(specifier);
        }).then(function (s) {
          return (0, _interopRequireWildcard2.default)(require(s));
        });
      }("@/views/".concat(view));
    };
  }
};
var _default = exports.default = permission;